import { Injectable } from '@angular/core';
import { SerwisBazowy } from '../bazowy.service';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../ogolne/auth.service';
import { ErrorService } from '../ogolne/error.service';
import { LoadingService } from '../ogolne/loading.service';
import { PojedynczyElementResponse } from 'src/app/modele/wspolne/pojedynczyElement';
import { PobierzDaneDoEkranuPorownywaniaDanychRezultat } from 'src/app/modele/projekty/magazyny/pobierzDaneDoEkranuPorownywaniaDanychRezultat';
import { PobierzDaneDoEdycjiFiltraRezultat } from 'src/app/modele/projekty/magazyny/pobierzDaneDoEdycjiFiltraRezultat';
import { EdytujFiltrPorownywaniaDanychModel } from 'src/app/modele/projekty/magazyny/edytujFiltrPorownywaniaDanychModel';
import { ResponseBazowy } from 'src/app/modele/wspolne/responseBazowy';
import { RejestrFiltrowanyRequest } from 'src/app/modele/wspolne/rejestrFiltrowanyRequest';
import { UruchomFiltrPorownywaniaDanychModel } from 'src/app/modele/projekty/magazyny/uruchomFiltrPorownywaniaDanychModel';
import { SrodkiZFiltruPorownywaniaDanych } from 'src/app/modele/projekty/magazyny/srodkiZFiltruPorownywaniaDanych';
import { PobierzStatystykiPracownikowFiltr } from 'src/app/modele/projekty/magazyny/pobierzStatystykiPracownikowFiltr';
import { StatystykiPracownikow } from 'src/app/modele/projekty/magazyny/statystykiPracownikow';
import { Zalacznik } from 'src/app/modele/wspolne/zalacznik';
import { PobierzDaneDoGenerowaniaRaportuPorownanychDanychRezultat } from 'src/app/modele/projekty/magazyny/pobierzDaneDoGenerowaniaRaportuPorownanychDanychRezultat';
import { WygenerujArkuszPorownaniaDanychModel } from 'src/app/modele/projekty/magazyny/wygenerujArkuszPorownaniaDanychModel';

@Injectable({
  providedIn: 'root',
})
export class PorownywanieDanychService extends SerwisBazowy {
  constructor(
    httpClient: HttpClient,
    authService: AuthService,
    errorService: ErrorService,
    loaderService: LoadingService,
    translate: TranslateService
  ) {
    super(httpClient, authService, errorService, loaderService, translate);
  }

  public pobierzDaneDoEkranuPorownywaniaDanych(
    idProjektu: string,
    idLokalizacji: string
  ) {
    return this.get<
      PojedynczyElementResponse<PobierzDaneDoEkranuPorownywaniaDanychRezultat>
    >(
      this.AdresApi +
        `PorownywanieDanych/PobierzDaneDoEkranuPorownywaniaDanych/${idProjektu}/${idLokalizacji}`
    );
  }

  public pobierzDaneDoEdycjiFiltra(
    idProjektu: string,
    idLokalizacji: string,
    idFiltra: string
  ) {
    return this.get<
      PojedynczyElementResponse<PobierzDaneDoEdycjiFiltraRezultat>
    >(
      this.AdresApi +
        `PorownywanieDanych/PobierzDaneDoEdycjiFiltra/${idProjektu}/${idLokalizacji}` +
        (idFiltra ? '?idFiltra=' + idFiltra : '')
    );
  }

  zapiszFiltr(model: EdytujFiltrPorownywaniaDanychModel) {
    return this.wykonajAkcje<
      EdytujFiltrPorownywaniaDanychModel,
      ResponseBazowy
    >(this.AdresApi + `PorownywanieDanych/EdytujFiltr`, model);
  }

  usunFiltr(idFiltra: string) {
    return this.wykonajAkcjeBezModelu<ResponseBazowy>(
      this.AdresApi + `PorownywanieDanych/UsunFiltr/${idFiltra}`
    );
  }

  uruchomFiltr(
    model: RejestrFiltrowanyRequest<UruchomFiltrPorownywaniaDanychModel>,
    zLadowaczem
  ) {
    if (zLadowaczem) {
      return this.wykonajAkcje<
        RejestrFiltrowanyRequest<UruchomFiltrPorownywaniaDanychModel>,
        PojedynczyElementResponse<SrodkiZFiltruPorownywaniaDanych>
      >(this.AdresApi + `PorownywanieDanych/UruchomFiltr`, model);
    } else {
      return this.wykonajAkcjeBezLadowacza<
        RejestrFiltrowanyRequest<UruchomFiltrPorownywaniaDanychModel>,
        PojedynczyElementResponse<SrodkiZFiltruPorownywaniaDanych>
      >(this.AdresApi + `PorownywanieDanych/UruchomFiltr`, model);
    }
  }

  pobierzStatystykiPracownikow(
    model: RejestrFiltrowanyRequest<PobierzStatystykiPracownikowFiltr>,
    zLadowaczem: boolean
  ) {
    if (zLadowaczem) {
      return this.wykonajAkcje<
        RejestrFiltrowanyRequest<PobierzStatystykiPracownikowFiltr>,
        PojedynczyElementResponse<StatystykiPracownikow>
      >(
        this.AdresApi + `PorownywanieDanych/PobierzStatystykiPracownikow`,
        model
      );
    } else {
      return this.wykonajAkcjeBezLadowacza<
        RejestrFiltrowanyRequest<PobierzStatystykiPracownikowFiltr>,
        PojedynczyElementResponse<StatystykiPracownikow>
      >(
        this.AdresApi + `PorownywanieDanych/PobierzStatystykiPracownikow`,
        model
      );
    }
  }

  //todo
  generujArkuszSpisu(
    idProjektu: string,
    idLokalizacji: string,
    idWybranegoFiltra: string
  ) {
    return this.get<PojedynczyElementResponse<Zalacznik>>(
      this.AdresApi +
        'EksportujDane/EksportujPorownaneDaneLokalizacji/' +
        idProjektu +
        '/' +
        idLokalizacji +
        '/' +
        idWybranegoFiltra
    );
  }

  pobierzDaneDoGenerowaniaRaportu(
    idProjektu: string,
    idLokalizacji: string,
    idFiltra: string
  ) {
    return this.get<
      PojedynczyElementResponse<PobierzDaneDoGenerowaniaRaportuPorownanychDanychRezultat>
    >(
      this.AdresApi +
        'PorownywanieDanych/PobierzDaneDoGenerowaniaRaportu/' +
        idProjektu +
        '/' +
        idLokalizacji +
        '/' +
        idFiltra
    );
  }

  public generujRaport(model: WygenerujArkuszPorownaniaDanychModel) {
    return this.wykonajAkcje<
      WygenerujArkuszPorownaniaDanychModel,
      PojedynczyElementResponse<Zalacznik>
    >(
      this.AdresApi + 'PorownywanieDanych/GenerujRaport',
      model,
      15 * 60 * 1000
    );
  }

  eksportujStatystykiPracownikow(idProjektu: string) {
    return this.get<PojedynczyElementResponse<Zalacznik>>(
      this.AdresApi +
        'PorownywanieDanych/EksportujStatystykiPracownikow/' +
        idProjektu
    );
  }
}
